import type { KioskConfig } from "../../api/kiosk";

const CODE = /^K1(\.[^./?#\s]+){5}$/;
const HTTPS_BASE = /^https:\/\/[^\s/?#]+(\/[^\s?#]*)?$/;

/**
 * Where the wall QR links (D58): the gym's own member portal, `https://<gym host>/app`, sent by the worker as
 * `memberBaseUrl` (the brand's connected domain, else `https://<brand-slug>.helmr.in/app`). VITE_MEMBER_BASE_URL
 * overrides it per build for local dev only. There is no shared default: with neither, this is null and the
 * wall shows no code rather than a link that is not the gym's. Trailing slashes are dropped; non-https values are ignored.
 */
export function memberBase(config?: Pick<KioskConfig, "memberBaseUrl"> | null): string | null {
  const env = (import.meta.env?.VITE_MEMBER_BASE_URL as string | undefined) || undefined;
  for (const c of [config?.memberBaseUrl, env]) {
    const v = c?.trim().replace(/\/+$/, "");
    if (v && HTTPS_BASE.test(v)) return v;
  }
  return null;
}

/** The https link the wall QR encodes, `<base>/k/<code>` (so `https://<gym host>/app/k/<code>`). A phone camera opens it; the member app can claim it as a universal link. */
export const wallLink = (base: string, code: string) => `${base}/k/${encodeURIComponent(code)}`;

/** The K1 code from a bare code or a `/k/<code>` link; null for anything else. */
export function parseWallLink(text: string): string | null {
  const t = text.trim();
  if (CODE.test(t)) return t;
  let u: URL;
  try { u = new URL(t); } catch { return null; }
  if (u.protocol !== "https:") return null;
  const m = /\/k\/([^/]+)\/?$/.exec(u.pathname);
  if (!m) return null;
  let code: string;
  try { code = decodeURIComponent(m[1]!); } catch { return null; }
  return CODE.test(code) ? code : null;
}
